import { Component, Input, OnInit } from '@angular/core';

import { RestaurantService } from './restaurant.service';

import { Restaurant } from './restaurant';

import 'rxjs/add/operator/switchMap';

@Component({
	selector: 'bottom-gallery',
	templateUrl: './bottom-gallery.component.html',
	styleUrls: ['./bottom-gallery.component.css']
})

export class BottomGalleryComponent implements OnInit {

	constructor(
		private m_restaurant_service: RestaurantService,
  	) {}
	m_restaurant: Restaurant;

	ngOnInit(): void {
		this.getRestaurant();
	}

	getRestaurant(): void {
		console.log("BottomGalleryComponent getRestaurant")
		this.m_restaurant_service.getRestaurant(this.m_restaurant_service.name).then(
			restaurant => {
				console.log("BottomGalleryComponent callback")
				this.m_restaurant = restaurant;
			}
		);
	}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/bottom-gallery.component.ts